// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-decos[data-v-410679c0]{z-index:-1;width:100%}.mc-deco[data-v-410679c0],.mc-decos[data-v-410679c0]{top:0;position:absolute}.mc-deco[data-v-410679c0]{width:70%;opacity:.3}.mc-deco[data-v-410679c0]:nth-of-type(odd){left:-35%}.mc-deco[data-v-410679c0]:nth-of-type(2n){right:-35%}@media screen and (max-width:768px){.mc-deco[data-v-410679c0]{width:90%}}", ""]);
// Exports
module.exports = exports;
